import { useEffect, useState } from "react";

/**
 * Debounce a value — used to drive recompute round-trips after the user has
 * stopped typing for `delayMs` (default 300 ms).
 */
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const id = window.setTimeout(() => setDebounced(value), delayMs);
		return () => window.clearTimeout(id);
	}, [value, delayMs]);

	return debounced;
};
